import React from "react";
import { Button, Box, Grid, Typography } from "@mui/material";
// import { Public } from "@mui/icons-material";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import YouTubeIcon from "@mui/icons-material/YouTube";
import manSvg from "../../../assets/images/landing/man.svg";
import home_page_bg from "../../../assets/images/landing/home_page_bg.png";
import { Hidden } from "@mui/material";

const Landing = () => {
  return (
    <Grid
      container
      sx={{
        backgroundImage: `url(${home_page_bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center center",
        height: "100vh",
        paddingLeft: "10%",
        paddingRight: "10%",
        paddingTop: "20vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "left",
        position: "relative",
        "@media (max-width: 600px)": {
          backgroundImage: `url(${home_page_bg})`,
          backgroundColor: "white",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          paddingTop: "80px",
          paddingBottom: "80px",
          paddingLeft: "20px",
          paddingRight: "20px",
          textAlign: "center",
          backgroundPosition: "left 70px ",
        },
      }}
    >
      <Grid
        item
        md={6}
        sx={{
          maxWidth: "600px",
          width: "100%",
          position: "relative",
          minHeight: "100vh",
          textAlign: "left",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            color: "black",
            mb: "20px",
            mt: "80px",
          }}
        >
          "Where ideas turn into reality"
        </Typography>

        <Button
          variant="contained"
          size="large"
          href="https://example.com"
          sx={{
            borderRadius: "100px",
            color: "white",
            fontSize: "20px",
            mb: "20px",
          }}
        >
          Join Us
        </Button>
        <Typography
          variant="body1"
          sx={{
            color: "black",
            fontSize: "18px",
            wordBreak: "break-word",
            maxWidth: "520px",
            "@media (max-width: 600px)": {
              fontSize: "16px",
            },
          }}
        >
          Developer Student Clubs are university based community groups for
          students interested in Google developer technologies. Students from
          all undergraduate or graduate programs with an interest in growing as
          a developer are welcome.
        </Typography>
        <Hidden smUp>
          <Box sx={{ position: "relative" }}>
            <img
              src={manSvg}
              alt="man"
              style={{
                position: "absolute",
                bottom: "0% !important",
                left: "50%",
                transform: "translateX(-50%)",
                maxWidth: "70%",
                height: "auto",
                display: "block",
              }}
            />
          </Box>
        </Hidden>
      </Grid>
      <Hidden smDown>
        <Grid
          item
          md={6}
          container
          direction="row"
          justify="flex-end"
          alignItems="flex-end"
          style={{ position: "relative" }}
        >
          <img
            src={manSvg}
            alt="man"
            style={{
              position: "absolute",
              transform: "translate(0, -6%)",
              top: "0%",
              bottom: "35%",
              right: 0,
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
        </Grid>
      </Hidden>

      {/* <Box
        sx={{
          position: "fixed",
          bottom: "60%",
          right: "20px",
          transform: "translateY(50%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: "10px",
        }}
      >
        <Button
          color="inherit"
          href="https://twitter.com/gdscsrmrmp"
          target="_blank"
          sx={{
            color: "blue",
            "&:hover": {
              color: "grey",
            },
          }}
          startIcon={<TwitterIcon />}
        />

        <Button
          color="inherit"
          href="https://www.instagram.com/gdscsrmrmp/"
          target="_blank"
          sx={{
            color: "blue",
            "&:hover": {
              color: "grey",
            },
          }}
          startIcon={<InstagramIcon />}
        />

        <Button
          color="inherit"
          href="https://www.youtube.com/channel/UCEym9CYeeSWiMtQwN9YQXOQ"
          target="_blank"
          sx={{
            color: "blue",
            "&:hover": {
              color: "grey",
            },
          }}
          startIcon={<YouTubeIcon />}
        />

        <Button
          color="inherit"
          href="#"
          target="_blank"
          sx={{
            color: "blue",
            "&:hover": {
              color: "grey",
            },
          }}
          startIcon={<Public />}
        />
      </Box> */}
    </Grid>
  );
};

export default Landing;